/**
 * Market Data Redux Slice
 */

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  socket: null,
  isConnected: false,
  marketData: {}, // { 'NSE|22': { lp, pc, v, ... } }
  depthData: {}, // { 'NSE|22': { bp1, sp1, ... } }
  subscribedSymbols: [],
  indices: {},
};

const marketSlice = createSlice({
  name: 'market',
  initialState,
  reducers: {
    setSocket: (state, action) => {
      state.socket = action.payload;
    },
    setConnected: (state, action) => {
      state.isConnected = action.payload;
    },
    updateMarketData: (state, action) => {
      const { e, tk, ...data } = action.payload;
      const key = `${e}|${tk}`;
      state.marketData[key] = {
        ...state.marketData[key],
        ...data,
        exchange: e,
        token: tk,
        lastUpdate: Date.now(),
      };
    },
    updateDepthData: (state, action) => {
      const { e, tk, ...data } = action.payload;
      const key = `${e}|${tk}`;
      state.depthData[key] = {
        ...state.depthData[key],
        ...data,
        exchange: e,
        token: tk,
        lastUpdate: Date.now(),
      };
    },
    addSubscribedSymbol: (state, action) => {
      const symbol = action.payload;
      const exists = state.subscribedSymbols.find(
        s => s.exchange === symbol.exchange && s.token === symbol.token
      );
      if (!exists) {
        state.subscribedSymbols.push(symbol);
      }
    },
    removeSubscribedSymbol: (state, action) => {
      const { exchange, token } = action.payload;
      state.subscribedSymbols = state.subscribedSymbols.filter(
        s => !(s.exchange === exchange && s.token === token)
      );
    },
    clearMarketData: (state) => {
      state.marketData = {};
      state.depthData = {};
      state.subscribedSymbols = [];
    },
  },
});

export const {
  setSocket,
  setConnected,
  updateMarketData,
  updateDepthData,
  addSubscribedSymbol,
  removeSubscribedSymbol,
  clearMarketData,
} = marketSlice.actions;

export default marketSlice.reducer;
